export default ($axios) => ({
  fetchAssessments () {
    return $axios.get('course-assessments')
  },
  fetchAssessmentById (id, config = {}) {
    return $axios.get(`course-assessments/${id}`, { ...config })
  },
  createAssessment (payload) {
    return $axios.post('course-assessments', { body: payload })
  },
  updateAssessment (id, payload) {
    return $axios.put(`course-assessments/${id}`, { body: payload })
  },
  deleteAssessment (id) {
    return $axios.delete(`course-assessments/${id}`)
  },
  fetchAssessmentOppsByUnitId (unitId) {
    return $axios.get(`assessment-opps/get-by-unit/${unitId}`)
  },
  fetchAssessmentOpps (query) {
    return $axios.get('assessment-opps', { query })
  },
  fetchAssessmentTypes (query) {
    return $axios.get('assessment-types', { query })
  }
})
